<div class="pdf-export">
  <div class="cpdf-start"></div>
  <!-- Page 1 - TAPE -->
  <div class="page-break cpdf-tape page-break-wrapper cpdf-section1">
    <div class="cpdf-header">
      <div class="deloitte-left_logo"></div>
    </div>
    <!--class="cpdf-content firstPage"-->
    <div class="cpdf-content firstPage">
      <div class="cpdf-logo"></div>
      <h1 class="reportNameTitle">{{ data?.ReportName }}</h1>
      <div class="cpdf-divider"></div>

      <h3 class="baselineTitle">
        <span class="baslineTitleText">{{ 'BaseLineHeader' | translate }}</span>
        <span class="baslineTitleText">{{ data?.BaselineName }}</span>
      </h3>
      <h4 class="baselineDescription">{{ data?.BaselineDescription }}</h4>

      <h3 class="reportDate">{{ data?.ReportDate }}</h3>
    </div>
  </div>

  <!-- Page 2 - EXPLANATION -->
  <div class="page-break cpdf-page">
    <div class="cpdf-header cpdf-header-wrapper2">
      <h1 class="comman_class21pt marT22">Business Chemistry</h1>
      <h2 class="comman_class11pt">
        <span>{{ data?.ReportName }} </span>
        <span>{{ 'BaseLinerHeaderWithHypen' | translate }}</span>
        <span> {{ data?.BaselineName }}</span>
      </h2>
    </div>
    <div class="cpdf-content">
      <h1 class="comman_class9pt padT0 padLeft0 setlineHeight">
        {{ 'UsingSciencetoImprovetheArtofRelationships' | translate }}
      </h1>

      <p class="comman_small9pt padLeft0">{{ 'ArtOfRelationshipsPara1' | translate }}</p>

      <p class="comman_small9pt padLeft0">{{ 'ArtOfRelationshipsPara2' | translate }}</p>

      <p class="comman_small9pt padLeft0">{{ 'ArtOfRelationshipsPara3' | translate }}</p>

      <div class="team_pageImage"></div>
      <p
        class="cpdf-imaged comman_small9pt padLeft0"
        [innerHTML]="'ArtOfRelationshipsPara4' | translate"
      ></p>

      <p class="comman_small9pt padLeft0">{{ 'ArtOfRelationshipsPara5' | translate }}</p>
    </div>
    <div class="cpdf-footer">
      <p class="cpdf-pagenumber marB20">2</p>
    </div>
  </div>

  <!-- Page 3 - SCATTER CHART -->
  <div class="page-break cpdf-page scatter-chart-page page3">
    <div class="cpdf-header">
      <h1 class="comman_class21pt comman_primarysecondary marT22">
        {{ 'PrimaryandSecondaryPreferences' | translate }}
      </h1>
      <h2 class="comman_class11pt">
        <span>{{ data?.ReportName }}</span>
        <span> {{ 'BaseLinerHeaderWithHypen' | translate }}</span>
        <span>{{ data?.BaselineName }}</span>
      </h2>
    </div>
    <div class="cpdf-content cpdf-content-wrapper">
      <p class="comman_small9pt marT0 padT0 padLeft0">
        {{
          'preferencesparadesc'
            | translate
            | replaceText: $safeNavigationMigration(data?.BaselineName)
        }}
      </p>

      <div class="cpdf-scatter-chart">
        <div class="cpdf-chart">
          <!-- This place the Number and Name on the graph -->
          <div *ngIf="data?.Scores.length > 25">
            <span *ngFor="let score of data?.Scores; let i = index">
              <span
                class="cpdf-scatter-chart-item"
                [ngStyle]="{ left: score.XYPoint.Key + '%', top: score.XYPoint.Value + '%' }"
              >
                <span class="cpdf-circle">{{ i + 1 }}</span>
              </span>
            </span>
          </div>

          <!-- This place the Name on the graph -->
          <div *ngIf="data?.Scores.length <= 25">
            <span *ngFor="let score of data?.Scores; let i = index">
              <span
                class="cpdf-scatter-chart-item"
                [ngStyle]="{ left: score.XYPoint.Key + '%', top: score.XYPoint.Value + '%' }"
              >
                <span class="cpdf-circle small"></span
                ><span class="cpdf-text">{{ score.FirstName + ' ' + score.LastName }}</span>
              </span>
            </span>
          </div>
        </div>
        <div class="cpdf-legend marT25">
          <div class="cpdf-item marB28">
            <img
              class="legend-img"
              width="60"
              src="./../../assets/images/teamSnapshot/fy17images/pioneer-square.png"
              alt="pioneer-square"
            />

            <h1 class="comman_class21pt padT8 marR15 legendCount">{{ data?.PioneerCount }}</h1>
            <p
              class="comman_small9pt legendDesc"
              [innerHTML]="'withprimaryPioneerpreferenceswithBreak' | translate"
            ></p>
          </div>
          <div class="cpdf-item marB28">
            <img
              class="legend-img"
              width="60"
              src="./../../assets/images/teamSnapshot/fy17images/driver-square.png"
              alt="driver-square"
            />

            <h1 class="comman_class21pt padT8 marR15 legendCount">{{ data?.DriverCount }}</h1>
            <p
              class="comman_small9pt legendDesc"
              [innerHTML]="'withprimaryDriverpreferenceswithBreak' | translate"
            ></p>
          </div>
          <div class="cpdf-item marB28">
            <img
              class="legend-img"
              width="60"
              src="./../../assets/images/teamSnapshot/fy17images/guardian-square.png"
              alt="guardian-square"
            />

            <h1 class="comman_class21pt padT8 marR15 legendCount">{{ data?.GuardianCount }}</h1>
            <p
              class="comman_small9pt legendDesc"
              [innerHTML]="'withprimaryGuardianpreferenceswithBreak' | translate"
            ></p>
          </div>
          <div class="cpdf-item marB28">
            <img
              class="legend-img"
              width="60"
              src="./../../assets/images/teamSnapshot/fy17images/integrator-square.png"
              alt="integrator-square"
            />

            <h1 class="comman_class21pt padT8 marR15 legendCount">{{ data?.IntegratorCount }}</h1>
            <p
              class="comman_small9pt legendDesc"
              [innerHTML]="'withprimaryIntegratorpreferenceswithBreak' | translate"
            ></p>
          </div>
        </div>
      </div>
    </div>
    <div class="cpdf-footer">
      <p class="cpdf-pagenumber">3</p>
    </div>
  </div>

  <!-- Page 4 - USER LISTS -->
  <!-- ko if: Scores().length > 25 -->
  <div class="page-break cpdf-page" *ngIf="data?.Scores.length > 25">
    <div class="cpdf-header page4Content cpdf-header-wrapper2">
      <h1 class="comman_class21pt marT22">{{ 'TeamSnapshotKeyText' | translate }}</h1>
      <h2 class="comman_class11pt">{{ data?.ReportName }}</h2>
    </div>
    <div class="cpdf-content userlist-page4-content-wrapper">
      <!-- ko if: Counts.DriverCount > 0-->
      <div class="cpdf-userlist cpdf-userlist-updt" *ngIf="data?.DriverCount > 0">
        <img
          src="./../../assets/images/teamSnapshot/fy17images/driver-square.png"
          alt="driver-square"
          width="45"
        />
        <h1 class="comman_class9pt userlist-header">{{ 'DriverText' | translate }}</h1>
        <div class="cpdf-divider"></div>

        <div *ngFor="let score of data?.Scores; let i = index">
          <p *ngIf="score.PrimaryType === 'Driver' && score.Count <= 113">
            <span class="cpdf-listnumber">{{ i + 1 }}</span
            ><span class="cpdf-listname">{{ score.FirstName + ' ' + score.LastName }}</span>
          </p>
        </div>
      </div>
      <!-- /ko -->
      <!-- ko if: Counts.IntegratorCount > 0-->
      <div class="cpdf-userlist cpdf-userlist-updt" *ngIf="data?.IntegratorCount > 0">
        <img
          src="./../../assets/images/teamSnapshot/fy17images/integrator-square.png"
          alt="Integrator"
          width="45"
        />
        <h1 class="comman_class9pt userlist-header">{{ 'IntegratorText' | translate }}</h1>
        <div class="cpdf-divider"></div>

        <div *ngFor="let score of data?.Scores; let i = index">
          <!-- ko if: PrimaryType is 'Integrator'  and Count <= 113  -->
          <p *ngIf="score.PrimaryType === 'Integrator' && score.Count <= 113">
            <span class="cpdf-listnumber">{{ i + 1 }}</span
            ><span class="cpdf-listname">{{ score.FirstName + ' ' + score.LastName }}</span>
          </p>
          <!-- /ko -->
        </div>
      </div>
      <!-- /ko -->
    </div>
    <div class="cpdf-footer page4-footer">
      <!-- ko if: Scores().length > 25 -->
      <p class="cpdf-pagenumber" *ngIf="data?.Scores.length > 25">4</p>
      <!-- /ko -->
    </div>
  </div>
  <!-- /ko -->
  <!-- Page 5 - USER LISTS -->
  <!-- ko if: Scores().length > 25 -->
  <div class="page-break cpdf-page full-width" *ngIf="data?.Scores.length > 25">
    <div class="cpdf-header page5Content cpdf-header-wrapper">
      <h1 class="comman_class21pt marT22">{{ 'TeamSnapshotKeyText' | translate }}</h1>
      <h2 class="comman_class11pt">{{ data?.ReportName }}</h2>
    </div>
    <div class="cpdf-content userlist-page5-content-wrapper">
      <!-- ko if: Counts.PioneerCount > 0-->
      <div class="cpdf-userlist cpdf-userlist-updt" *ngIf="data?.PioneerCount > 0">
        <img
          src="./../../assets/images/teamSnapshot/fy17images/pioneer-square.png"
          alt="pioneer-square"
          width="45"
        />
        <h1 class="comman_class9pt userlist-header">{{ 'PioneerText' | translate }}</h1>
        <div class="cpdf-divider marB0"></div>

        <div *ngFor="let score of data?.Scores; let i = index">
          <!-- ko if: PrimaryType is 'Pioneer' and Count <= 113  -->
          <p *ngIf="score.PrimaryType === 'Pioneer' && score.Count <= 113">
            <span class="cpdf-listnumber">{{ i + 1 }}</span
            ><span class="cpdf-listname">{{ score.FirstName + ' ' + score.LastName }}</span>
          </p>
          <!-- /ko -->
        </div>
      </div>
      <!-- /ko -->
      <!-- ko if: Counts.GuardianCount > 0-->
      <div class="cpdf-userlist cpdf-userlist-updt" *ngIf="data?.GuardianCount > 0">
        <img
          src="./../../assets/images/teamSnapshot/fy17images/guardian-square.png"
          alt="guardian-square"
          width="45"
        />
        <h1 class="comman_class9pt userlist-header">{{ 'GuardianText' | translate }}</h1>
        <div class="cpdf-divider marB0"></div>

        <div *ngFor="let score of data?.Scores; let i = index">
          <!-- ko if: PrimaryType is 'Guardian' && Count <= 113  -->
          <p *ngIf="score.PrimaryType === 'Guardian' && score.Count <= 113">
            <span class="cpdf-listnumber">{{ i + 1 }}</span
            ><span class="cpdf-listname">{{ score.FirstName + ' ' + score.LastName }}</span>
          </p>
          <!-- /ko -->
        </div>
      </div>
      <!-- /ko -->
    </div>
    <div class="cpdf-footer page5-footer">
      <!-- ko if: Scores().length > 25 -->
      <p class="cpdf-pagenumber" *ngIf="data?.Scores.length > 25">5</p>
      <!-- /ko -->
    </div>
  </div>
  <!-- /ko -->
  <!-- Page 6 - SCATTER INFO -->
  <div class="page-break cpdf-page topNeg10">
    <div class="cpdf-header page6Header cpdf-header-wrapper4">
      <!--<div class="comman_logo"></div>-->
      <h1 class="comman_class21pt comman_primarysecondary marT22">
        {{ 'PrimaryandSecondaryPreferences' | translate }}
      </h1>
      <h2 class="comman_class11pt">
        <span>{{ data?.ReportName }}</span>
        <span>{{ 'BaseLinerHeaderWithHypen' | translate }}</span>
        <span>{{ data?.BaselineName }}</span>
      </h2>
    </div>
    <div class="cpdf-content page6Content">
      <h1 class="comman_class9pt padLeft0 padT0 marT0">
        <i>{{ 'HowToInterpretGraphText' | translate }}</i>
      </h1>

      <div class="cpdf-box">
        <div
          class="cpdf-third"
          [ngClass]="{ 'cpdf-third-max-score': $safeNavigationMigration(data?.Scores.length) > 25 }"
        >
          <div class="cpdf-third-row">
            <img
              src="./../../assets/images/teamSnapshot/fy17images/quadrant.png"
              alt="quadrant"
              width="100"
            />
            <h1 class="interpret_small9pt interpret_20pt">{{ 'QuadrantText' | translate }}</h1>
          </div>
          <p class="interpret_small9pt interpret_20pt" [innerHTML]="'QUADRANTDesc' | translate"></p>
        </div>

        <div class="cpdf-third">
          <div class="cpdf-third-row">
            <img
              src="./../../assets/images/teamSnapshot/fy17images/section.png"
              alt="section"
              width="100"
            />
            <h1 class="interpret_small9pt interpret_20pt">{{ 'SectionText' | translate }}</h1>
          </div>
          <p class="interpret_small9pt interpret_20pt" [innerHTML]="'SECTIONDesc' | translate"></p>
        </div>

        <div class="cpdf-third">
          <div class="cpdf-third-row">
            <img
              src="./../../assets/images/teamSnapshot/fy17images/distance.png"
              alt="distance"
              width="100"
            />
            <h1 class="interpret_small9pt interpret_20pt">{{ 'DistanceText' | translate }}</h1>
          </div>
          <p class="interpret_small9pt interpret_20pt" [innerHTML]="'DISTANCEDesc' | translate"></p>
        </div>
      </div>
    </div>
    <div class="cpdf-footer page6-footer">
      <!-- ko if: Scores().length <= 25 -->
      <p *ngIf="data?.Scores.length <= 25" class="cpdf-pagenumber">4</p>
      <!-- /ko -->
      <!-- ko if: Scores().length > 25 -->
      <p class="cpdf-pagenumber" *ngIf="data?.Scores.length > 25">6</p>
      <!-- /ko -->
    </div>
  </div>
  <!-- Page 7 - added extra page members are less than 25 -->
  <!-- ko if: Scores().length <= 25 -->
  <div class="page-break cpdf-page teamSnapshotGraph2" *ngIf="data?.Scores.length <= 25">
    <div class="cpdf-header page7Header cpdf-header-wrapper">
      <!--<div class="comman_logo"></div>-->
      <h1 class="comman_class21pt comman_primarysecondary">
        {{ 'PrimaryandSecondaryPreferences' | translate }}
      </h1>
      <h2 class="comman_class11pt">
        <span>{{ data?.ReportName }}</span>
        <span>{{ 'BaseLinerHeaderWithHypen' | translate }}</span>
        <span>{{ data?.BaselineName }}</span>
      </h2>
    </div>
    <div class="cpdf-content page7Content">
      <p class="comman_small9pt padLeft0 padT0 marT0">
        {{
          'preferencesparadesc'
            | translate
            | replaceText: $safeNavigationMigration(data?.BaselineName)
        }}
      </p>

      <div class="cpdf-scatter-chart cpdf-scatter-chart1">
        <div class="cpdf-chart cpdf-chart-wrapper">
          <!-- This place the Number and Name on the graph -->
          <span *ngFor="let score of data?.Scores; let i = index">
            <span
              class="cpdf-scatter-chart-item"
              [ngStyle]="{ left: score.XYPoint.Key + '%', top: score.XYPoint.Value + '%' }"
            >
              <span class="cpdf-circle">{{ i + 1 }}</span>
            </span>
          </span>
        </div>
        <div *ngIf="data?.Scores.length <= 25" class="rightLegend">
          <div class="cpdf-legend">
            <div class="cpdf-item">
              <img
                src="./../../assets/images/teamSnapshot/fy17images/pioneer-square.png"
                alt=""
                class="legendSize"
              />
              <span class="pioneerCount">{{ data?.PioneerCount }}</span>
              <span
                class="font18pt"
                [innerHTML]="'withprimaryPioneerpreferences' | translate"
              ></span>
              <div class="scores-wrapper columCount2">
                <div *ngFor="let score of data?.Scores; let i = index">
                  <!-- ko if: PrimaryType is 'Pioneer'   -->
                  <div *ngIf="score.PrimaryType === 'Pioneer'" class="cpdf-list-wrapper">
                    <span class="cpdf-listnumber">{{ i + 1 }}</span
                    ><span class="cpdf-listname">{{ score.FirstName + ' ' + score.LastName }}</span>
                  </div>
                  <!-- /ko -->
                </div>
              </div>
            </div>
            <div class="cpdf-item">
              <img
                src="./../../assets/images/teamSnapshot/fy17images/driver-square.png"
                alt=""
                class="legendSize"
              />
              <span class="driverCount">{{ data?.DriverCount }}</span>
              <span
                class="font18pt"
                [innerHTML]="'withprimaryDriverpreferences' | translate"
              ></span>
              <div class="scores-wrapper columCount2">
                <div *ngFor="let score of data?.Scores; let i = index">
                  <!-- ko if: PrimaryType is 'Driver'   -->
                  <div *ngIf="score.PrimaryType === 'Driver'" class="cpdf-list-wrapper">
                    <span class="cpdf-listnumber">{{ i + 1 }}</span
                    ><span class="cpdf-listname">{{ score.FirstName + ' ' + score.LastName }}</span>
                  </div>
                  <!-- /ko -->
                </div>
              </div>
            </div>
            <div class="cpdf-item">
              <img
                src="./../../assets/images/teamSnapshot/fy17images/guardian-square.png"
                alt=""
                class="legendSize"
              />
              <span class="guardianCount">{{ data?.GuardianCount }}</span>
              <span
                class="font18pt"
                [innerHTML]="'withprimaryGuardianpreferences' | translate"
              ></span>
              <div class="scores-wrapper columCount2">
                <div *ngFor="let score of data?.Scores; let i = index">
                  <!-- if PrimaryType is 'Guardian'   -->
                  <div *ngIf="score.PrimaryType === 'Guardian'" class="cpdf-list-wrapper">
                    <span class="cpdf-listnumber">{{ i + 1 }}</span
                    ><span class="cpdf-listname">{{ score.FirstName + ' ' + score.LastName }}</span>
                  </div>
                  <!-- /ko -->
                </div>
              </div>
            </div>
            <div class="cpdf-item">
              <img
                src="./../../assets/images/teamSnapshot/fy17images/integrator-square.png"
                alt=""
                class="legendSize"
              />
              <span class="integratorCount">{{ data?.IntegratorCount }}</span>
              <span
                class="font18pt"
                [innerHTML]="'withprimaryIntegratorpreferences' | translate"
              ></span>
              <div class="scores-wrapper columCount2">
                <div *ngFor="let score of data?.Scores; let i = index">
                  <!-- ko if: PrimaryType is 'Integrator'   -->
                  <div *ngIf="score.PrimaryType === 'Integrator'" class="cpdf-list-wrapper">
                    <span class="cpdf-listnumber">{{ i + 1 }}</span
                    ><span class="cpdf-listname">{{ score.FirstName + ' ' + score.LastName }}</span>
                  </div>
                  <!-- /ko -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cpdf-footer">
      <!-- ko if: Scores().length <= 25 -->
      <p class="cpdf-pagenumber cpdf-pagenumber-para" *ngIf="data?.Scores.length <= 25">5</p>
      <!-- /ko -->
      <!-- ko if: Scores().length > 25 -->
      <p class="cpdf-pagenumber" *ngIf="data?.Scores.length > 25">7</p>
      <!-- /ko -->
    </div>
  </div>
  <!-- /ko -->
  <!-- Page 8 - PIE CHART -->
  <div class="page-break cpdf-page">
    <div class="cpdf-header page8Header cpdf-header-wrapper">
      <h1 class="comman_class21pt marT22">{{ 'TeamCompositionText' | translate }}</h1>
      <h2 class="comman_class11pt">
        <span>{{ data?.ReportName }}</span>
        <span>{{ 'BaseLinerHeaderWithHypen' | translate }}</span>
        <span>{{ data?.BaselineName }}</span>
      </h2>
    </div>
    <div
      class="cpdf-content page8Content"
      [ngClass]="{ minScoreContent: $safeNavigationMigration(data?.Scores.length) <= 25 }"
    >
      <p
        class="para"
        [innerHTML]="
          'TeamMemberDescription'
            | translate
            | replaceText: $safeNavigationMigration(data?.BaselineName)
        "
      ></p>

      <!-- Charts -->
      <div class="cpdf-table-row">
        <div class="cpdf-table-data cpdf-table-title">
          <img
            class="imgStyle firstTitle firstTitleImg"
            src="./../../assets/images/teamSnapshot/firstTitle.png"
            alt="firstTitle"
          />
        </div>
        <div class="cpdf-table-data cpdf-table-data-wrapper">
          <h1 class="comman_small9pt primaryTypeText">{{ 'PrimaryTypeText' | translate }}</h1>
          <h1 class="comman_small9pt teamTraitsText">{{ 'TeamTraitsText' | translate }}</h1>

          <div id="totalPercentage" class="cpdf-pie-chart">
            <div id="primaryTypeChart"></div>
            <div id="primaryTypeLabels"></div>
          </div>
          <div id="taitsPercentage" class="cpdf-pie-chart">
            <div id="teamTraitChart"></div>
            <div id="teamTraitLabels"></div>
          </div>
          <div class="cpdf-piechart-legend">
            <div class="wrapper">
              <span class="square P"></span><span class="label_">P</span>
              <span class="square D"></span><span class="label_">D</span>
              <span class="square G"></span><span class="label_">G</span>
              <span class="square I"></span><span class="label_">I</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Teams -->
      <div class="cpdf-table-row">
        <div class="cpdf-table-data cpdf-table-title">
          <img
            class="imgStyle secondTitleImage"
            src="./../../assets/images/teamSnapshot/secondTitle.png"
            alt="secondTitle"
          />
        </div>
        <div class="cpdf-table-data cpdf-td-wrapper">
          <h2 class="cpdf-pioneer comman_small9pt">{{ 'PioneerText' | translate }}</h2>
          <h2 class="cpdf-driver comman_small9pt">{{ 'DriverText' | translate }}</h2>
          <h2 class="cpdf-guardian comman_small9pt">{{ 'GuardianText' | translate }}</h2>
          <h2 class="cpdf-integrator comman_small9pt">{{ 'IntegratorText' | translate }}</h2>

          <ul class="cpdf-pattern-do cpdf-pioneer team_small9pt cpdf-pattern-list">
            <li>{{ 'PioneerCollectiveText' | translate }}</li>
            <li>{{ 'PioneerFocusText' | translate }}</li>
            <li>{{ 'PioneerFunText' | translate }}</li>
          </ul>
          <ul class="cpdf-pattern-do cpdf-driver team_small9pt cpdf-pattern-list">
            <li>{{ 'DriverQuickDecisionsText' | translate }}</li>
            <li>{{ 'DriverFocusText' | translate }}</li>
            <li>{{ 'DriverCompetitiveText' | translate }}</li>
          </ul>
          <ul class="cpdf-pattern-do cpdf-guardian team_small9pt cpdf-pattern-list">
            <li>{{ 'GuardianMeticulousText' | translate }}</li>
            <li>{{ 'GuardianFocusText' | translate }}</li>
            <li>{{ 'GuardianRespectForRulesText' | translate }}</li>
          </ul>
          <ul class="cpdf-pattern-do cpdf-integrator cpdf-noborder team_small9pt cpdf-pattern-list">
            <li>{{ 'IntegratorDiplomacyText' | translate }}</li>
            <li>{{ 'IntegratorFocusText' | translate }}</li>
            <li>{{ 'IntegratorPositivityText' | translate }}</li>
          </ul>
        </div>
      </div>

      <div class="cpdf-table-divider cpdf-first"></div>
      <div class="cpdf-table-divider"></div>

      <!-- Individuals -->
      <div class="cpdf-table-row">
        <div class="cpdf-table-data cpdf-table-title">
          <img
            class="imgStyle"
            src="./../../assets/images/teamSnapshot/thirdTitle.png"
            alt="thirdTitle"
          />
        </div>
        <div class="cpdf-table-data">
          <ul class="cpdf-pattern-do cpdf-pioneer team_small9pt">
            <li>{{ 'PioneerEnergyText' | translate }}</li>
            <li>{{ 'PioneerAskingText' | translate }}</li>
            <li>{{ 'PionnerChallengingText' | translate }}</li>
          </ul>
          <ul class="cpdf-pattern-do cpdf-driver team_small9pt">
            <li>{{ 'DriverPushingText' | translate }}</li>
            <li>{{ 'DriverPromotingDirectnessText' | translate }}</li>
            <li>{{ 'DriverGettingThingsDoneText' | translate }}</li>
          </ul>
          <ul class="cpdf-pattern-do cpdf-guardian team_small9pt">
            <li>{{ 'GuardianGroundingSolutionsText' | translate }}</li>
            <li>{{ 'GuardianUnderstandingLogisticsText' | translate }}</li>
            <li>{{ 'GuardianReducingReworkText' | translate }}</li>
          </ul>
          <ul class="cpdf-pattern-do cpdf-integrator cpdf-noborder team_small9pt">
            <li>{{ 'IntegratorFacilitatingGroupText' | translate }}</li>
            <li>{{ 'IntegratorSynthesizingIdeasText' | translate }}</li>
            <li>{{ 'IntegratorUnderstandingBroaderText' | translate }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cpdf-footer page7-footer">
      <!-- ko if: Scores().length <= 25 -->
      <p class="cpdf-pagenumber" *ngIf="data?.Scores.length <= 25">6</p>
      <!-- /ko -->
      <!-- ko if: Scores().length > 25 -->
      <p class="cpdf-pagenumber" *ngIf="data?.Scores.length > 25">7</p>
      <!-- /ko -->
    </div>
  </div>

  <!-- Page 8 - TERMS AND CONDITIONS -->
  <div class="page-break cpdf-page page9">
    <div class="cpdf-header page9Header cpdf-header-wrapper3"></div>
    <div class="cpdf-footer cpdf-footer-content">
      <h1 class="interpret_small9pt">{{ 'AboutthispublicationHeader' | translate }}</h1>
      <p class="comman_small9pt comman_22pt">{{ 'Aboutthispublicationpara1' | translate }}</p>
      <p class="comman_small9pt comman_22pt">{{ 'Aboutthispublicationpara2' | translate }}</p>

      <h1 class="interpret_small9pt marT38">{{ 'AboutDeloitteHeader' | translate }}</h1>
      <p class="comman_small9pt comman_22pt">{{ 'AboutDeloittepara' | translate }}</p>

      <br />
      <br />
      <br />
      <br />
      <p class="cpdf-copyright">
        Copyright ©
        {{ currentyear }} {{ 'Copyright' | translate }}
      </p>
      <p class="cpdf-copyright">{{ 'DeloitteMemberFirm' | translate }}</p>
      <br />
      <br />
      <br />
      <br />
      <!-- ko if: Scores().length <= 25 -->
      <p class="cpdf-pagenumber page9-footer" *ngIf="data?.Scores.length <= 25">7</p>
      <!-- /ko -->
      <!-- ko if: Scores().length > 25 -->
      <p class="cpdf-pagenumber page9-footer" *ngIf="data?.Scores.length > 25">8</p>
      <!-- /ko -->
    </div>
  </div>
</div>
